import React from 'react';
import PropTypes from 'prop-types';

export const AppContext = React.createContext({
    showingLoadingIcon: false,
    onFirstFullResImageLoaded: null,
    setLoadingIconVisibility: null,
    currentSceneName: null,
    setCurrentSceneName: null,
    showQuiz: false,
    showHotspots: false,
    setQuizVisibility: null,
    showWelcomeModal: PropTypes.number,
    setShowWelcomeModal: null,
    setQuizSceneProductSku: null,
    quizSceneProductSku:null 
});
